<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h6 class="prd-h6"> Text Of Notices </h6>
<div class="card" >
    <div class="card-body" *ngIf = 'displayState.workingDiv'>
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />

<div class="row" *ngIf='!this.displayState.noticeDiv' >
  <div class="col-md-2 offset-1">
      <button class="btn btn-sm btn-link" (click)="newNotice()">New Notice Text</button>
  </div>
</div>

<div class="row" *ngIf = 'displayState.gridDiv'>
  <div class="col-md-10 offset-1">
    <p-table [value]="noticeList" [scrollable]="true" scrollHeight="600px"  >
      <ng-template pTemplate="header">
          <tr style="font-size:smaller">
              <th style="width: 8%" >&nbsp;</th>
              <th [pSortableColumn]="'type'" style="width: 14%" >
                  Code
                  <p-sortIcon [field]="'type'"></p-sortIcon>
              </th>
              <th style="width: 35%">
                  Text1
              </th>
              <th style="width: 35%">
                Text2
            </th>
            <th style="width: 8%" >&nbsp;</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-notice>
          <tr style="font-size: small;">
              <td style="width: 8%">
                  <button class='btn btn-sm btn-link' (click)="onSelect(notice)">Select</button>
              </td>
              <td style="width: 14%">{{notice.type}}</td>
              <td style="width: 35%">{{notice.text1?.length<50?notice.text1: notice.text1.slice(0,50)+'...'}}</td>
              <td style="width: 35%">{{notice.text2?.length<50?notice.text2: notice.text2.slice(0,50)+'...'}}</td>
              <td style="width: 8%">
                <button class='btn btn-sm btn-link' (click)="deleteNotice(notice)" [disabled]="userType === 'Read-Only' || userType === 'Appraiser'">Delete</button>
            </td>

          </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="row">
            <div class="col-md-2" style="text-align: left;"># of items: {{ noticeList?.length }}</div>
        </div>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="row" *ngIf='displayState.editNoticeDiv'>
    <div class="card bg-light col-md-10 offset-1">
        <div class="card-body">
            <div class="form-row">
                <label for="code" class="col-md-1 col-form-label prd-label">Notice Code</label>
                <input type="text" class="form-control col-md-2 prd-required" id="code" [(ngModel)]="myNotice.type">
            </div>
            <br />
           <div class="form-row">
                <!-- Notice text1 -->
                <label for="notText1" class="col-md-1 col-form-label prd-label">Text1</label>
                <textarea rows="10" class="form-control col-md-10 prd-required" id="notText1" [(ngModel)]="myNotice.text1"></textarea>
            </div>
            <br />
            <div class="form-row">
                <!-- Notice text2 -->
                <label for="notText2" class="col-md-1 col-form-label prd-label">Text2</label>
                <textarea rows="5" class="form-control col-md-10" id="notText2" [(ngModel)]="myNotice.text2"></textarea>
            </div>
            <br />
            <div class="form-row">
                <!-- Buttons -->
                <button class="btn btn-success offset-5" (click)="saveNotice()" [disabled] = "displayState.saveDisabled" >Save</button>
                <button class="btn btn-warning offset-1" (click)="cancelEntry()">Cancel</button>
            </div>
        </div>
    </div>
</div>
